import { render, staticRenderFns } from "./VRequestObservers.vue?vue&type=template&id=0113e79b"
import script from "./VRequestObservers.vue?vue&type=script&lang=js"
export * from "./VRequestObservers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports